import type { OrgType } from './persona'

export const EQUIPMENT_CATEGORY_ICON_NAMES = [
  'Bird',
  'Truck',
  'Sailboat',
  'Tent',
  'Dog',
  'ShieldCheck',
  'Cpu',
  'Package',
  'Wrench',
  'Anchor',
  'Box',
  'Archive',
  'Crosshair',
  'Target',
  'Binoculars',
  'Compass',
  'Radio',
  'Flashlight',
  'Backpack',
  'LifeBuoy',
  'Hammer',
  'Fish',
] as const

export type EquipmentCategoryIconName = (typeof EQUIPMENT_CATEGORY_ICON_NAMES)[number]

export type EquipmentCategory = {
  id: string
  name: string
  label: string
  iconName?: string
  isDefault: boolean
  sortOrder: number
  createdByName?: string
}

export type EquipmentCondition = 'new' | 'good' | 'fair' | 'poor' | 'replace'

export type EquipmentLocationType = 'blind' | 'zone' | 'property' | 'storage'

export type EquipmentPlaceType = 'blind' | 'zone' | 'property' | 'custom_location'

export type EquipmentItem = {
  id: string
  orgId: string
  orgType: OrgType
  name: string
  category?: EquipmentCategory
  quantity: number
  condition?: EquipmentCondition
  locationType?: EquipmentLocationType
  locationId?: string
  locationLabel?: string
  blindId?: string
  zoneId?: string
  propertyId?: string
  customLocationId?: string
  assignedTo?: string
  assigneeName?: string
  purchaseDate?: string
  unitCost?: number
  photoUrl?: string
  notes?: string
  reorderUrl?: string
  serialNumber?: string
  insuredValue?: number
  warrantyExpiresAt?: string
  createdBy?: string
  creatorName?: string
  latitude?: number
  longitude?: number
  placeName?: string
  placeType?: EquipmentPlaceType
  openTaskCount?: number
  createdAt: string
  updatedAt: string
}

export type EquipmentStats = {
  total: number
  needsAttention: number
  inStorage: number
  replaceCount: number
  totalValue: number
  totalInsuredValue: number
}

export type EquipmentPhoto = {
  id: string
  equipmentItemId: string
  orgId: string
  filename: string
  mimetype: string
  cloudStorageUrl?: string
  thumbnailUrl?: string
  isPrimary: boolean
  caption?: string
  createdAt: string
}

export const EQUIPMENT_CONDITIONS: readonly EquipmentCondition[] = [
  'new',
  'good',
  'fair',
  'poor',
  'replace',
]

export const EQUIPMENT_LOCATION_TYPES: readonly EquipmentLocationType[] = [
  'blind',
  'zone',
  'property',
  'storage',
]

export const EQUIPMENT_CONDITION_LABELS: Record<EquipmentCondition, string> = {
  new: 'New',
  good: 'Good',
  fair: 'Fair',
  poor: 'Poor',
  replace: 'Replace',
}

export const EQUIPMENT_LOCATION_TYPE_LABELS: Record<EquipmentLocationType, string> = {
  blind: 'Blind',
  zone: 'Zone',
  property: 'Property',
  storage: 'Storage',
}
